/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
import '../../../bizbank/service';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "card": {
                "nested": {
                  "GetCardAtmLimitsRequest": {
                    "fields": {
                      "cardToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetCardAtmLimitsResponse": {
                    "fields": {
                      "limits": {
                        "type": "squareup.bbfrontend.dashboard.card.GetCardAtmLimitsResponse.Limit",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Cadence": {
                        "values": {
                          "DAILY": 1,
                          "WEEKLY": 2,
                          "MONTHLY": 3,
                          "PER_TRANSACTION": 4
                        }
                      },
                      "Limit": {
                        "fields": {
                          "cadence": {
                            "type": "squareup.bbfrontend.dashboard.card.GetCardAtmLimitsResponse.Cadence",
                            "id": 1,
                            "rule": "optional"
                          },
                          "availableToSpendAmount": {
                            "type": "squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "limitAmount": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "GetCardRelationshipsRequest": {
                    "fields": {
                      "cardToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetCardRelationshipsResponse": {
                    "fields": {
                      "relationships": {
                        "type": "squareup.bbfrontend.dashboard.card.GetCardRelationshipsResponse.Relationship",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Relationship": {
                        "values": {
                          "RELATIONSHIP_DO_NOT_USE": 0,
                          "RELATIONSHIP_ACCOUNT_HOLDER": 1,
                          "RELATIONSHIP_CARD_HOLDER": 2
                        }
                      }
                    }
                  },
                  "GetPrimaryCardDataRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetPrimaryCardDataResponse": {
                    "fields": {
                      "card": {
                        "type": "squareup.bizbank.service.CardData",
                        "id": 1,
                        "rule": "optional"
                      },
                      "error": {
                        "type": "squareup.bbfrontend.dashboard.card.GetPrimaryCardDataResponse.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "UNKNOWN": 1,
                          "NO_CARD_FOUND": 2
                        }
                      }
                    }
                  },
                  "DashboardWebCardService": {
                    "methods": {
                      "GetCardAtmLimits": {
                        "requestType": "squareup.bbfrontend.dashboard.card.GetCardAtmLimitsRequest",
                        "responseType": "squareup.bbfrontend.dashboard.card.GetCardAtmLimitsResponse"
                      },
                      "GetCardRelationships": {
                        "requestType": "squareup.bbfrontend.dashboard.card.GetCardRelationshipsRequest",
                        "responseType": "squareup.bbfrontend.dashboard.card.GetCardRelationshipsResponse"
                      },
                      "GetPrimaryCardData": {
                        "requestType": "squareup.bbfrontend.dashboard.card.GetPrimaryCardDataRequest",
                        "responseType": "squareup.bbfrontend.dashboard.card.GetPrimaryCardDataResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetCardAtmLimitsRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetCardAtmLimitsResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetCardAtmLimitsResponse?.nested?.Cadence && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetCardAtmLimitsResponse?.nested?.Limit && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetCardRelationshipsRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetCardRelationshipsResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetCardRelationshipsResponse?.nested?.Relationship && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetPrimaryCardDataRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetPrimaryCardDataResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.GetPrimaryCardDataResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.card?.nested?.DashboardWebCardService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetCardAtmLimitsRequest @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 40:1
 */
export const GetCardAtmLimitsRequest = $root.lookupType('squareup.bbfrontend.dashboard.card.GetCardAtmLimitsRequest');
fixType(GetCardAtmLimitsRequest);
Builder.createAndAttachToType(GetCardAtmLimitsRequest);
/**
 * SOURCE GetCardAtmLimitsResponse @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 44:1
 */
export const GetCardAtmLimitsResponse = $root.lookupType('squareup.bbfrontend.dashboard.card.GetCardAtmLimitsResponse');
fixType(GetCardAtmLimitsResponse);
Builder.createAndAttachToType(GetCardAtmLimitsResponse);
/**
 * SOURCE Cadence @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 47:3
 */
GetCardAtmLimitsResponse.Cadence = $root.lookupEnum('squareup.bbfrontend.dashboard.card.GetCardAtmLimitsResponse.Cadence').values;
/**
 * SOURCE Limit @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 54:3
 */
GetCardAtmLimitsResponse.Limit = $root.lookupType('squareup.bbfrontend.dashboard.card.GetCardAtmLimitsResponse.Limit');
fixType(GetCardAtmLimitsResponse.Limit);
Builder.createAndAttachToType(GetCardAtmLimitsResponse.Limit);
/**
 * SOURCE GetCardRelationshipsRequest @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 61:1
 */
export const GetCardRelationshipsRequest = $root.lookupType('squareup.bbfrontend.dashboard.card.GetCardRelationshipsRequest');
fixType(GetCardRelationshipsRequest, {
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetCardRelationshipsRequest);
/**
 * SOURCE GetCardRelationshipsResponse @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 65:1
 */
export const GetCardRelationshipsResponse = $root.lookupType('squareup.bbfrontend.dashboard.card.GetCardRelationshipsResponse');
fixType(GetCardRelationshipsResponse);
Builder.createAndAttachToType(GetCardRelationshipsResponse);
/**
 * SOURCE Relationship @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 68:3
 */
GetCardRelationshipsResponse.Relationship = $root.lookupEnum('squareup.bbfrontend.dashboard.card.GetCardRelationshipsResponse.Relationship').values;
/**
 * SOURCE GetPrimaryCardDataRequest @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 75:1
 */
export const GetPrimaryCardDataRequest = $root.lookupType('squareup.bbfrontend.dashboard.card.GetPrimaryCardDataRequest');
fixType(GetPrimaryCardDataRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetPrimaryCardDataRequest);
/**
 * SOURCE GetPrimaryCardDataResponse @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 79:1
 */
export const GetPrimaryCardDataResponse = $root.lookupType('squareup.bbfrontend.dashboard.card.GetPrimaryCardDataResponse');
fixType(GetPrimaryCardDataResponse);
Builder.createAndAttachToType(GetPrimaryCardDataResponse);
/**
 * SOURCE Error @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 83:3
 */
GetPrimaryCardDataResponse.Error = $root.lookupEnum('squareup.bbfrontend.dashboard.card.GetPrimaryCardDataResponse.Error').values;
/**
 * SOURCE DashboardWebCardService @ squareup/bbfrontend/dashboardweb/card/card_service.proto at 14:1
 */
export const DashboardWebCardService = $root.lookupService('squareup.bbfrontend.dashboard.card.DashboardWebCardService');